import { render, staticRenderFns } from "./GoIn.vue?vue&type=template&id=547fd3a8&scoped=true&"
import script from "./GoIn.vue?vue&type=script&lang=js&"
export * from "./GoIn.vue?vue&type=script&lang=js&"
import style0 from "./GoIn.vue?vue&type=style&index=0&id=547fd3a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547fd3a8",
  null
  
)

export default component.exports